import { useGraphqlQuery } from "@bsm/component"
import { ContractManagerQuery } from "../queries/ContractManagerQuery"
import { TContract } from "@bsm/graphql"
import _ from "lodash"

export const useContractManagerQuery = (userId?: number, type?: string, suspense?: boolean) => {
    return useGraphqlQuery<ContractManagerQuery, TContract>(
        new ContractManagerQuery({
            data: {
                user: { id: userId }
            },
            leaveTypeDesignation: type
        }), 
        { suspense, enabled: !!userId && userId != -1 }
    )
}
